import axios from 'axios'
// service.defaults.headers.post['Content-Type'] = 'application/json';
import $router from '../router';
import commonJs from '@/utils/common-js'
import { getDocumentInfoForUrl } from '@/utils/common-api';
import cErrorDialog from '@/components/Dialog/cErrorDialog'
const service = axios.create({
    baseURL: process.env.API,
    timeout: 80000 // request timeout
})

//pc or 移动端判断方法
function isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return flag;
}

function getCookie(c_name) {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(c_name + '=')
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1
      let c_end = document.cookie.indexOf(';', c_start)
      if (c_end == -1) c_end = document.cookie.length
      return unescape(document.cookie.substring(c_start, c_end))
    }
  }
  return ''
}


//X-PF 1: iOS  2: Android  3:Web
function judgeIosAndroid() {
    if (isMobile()) {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端或者uc浏览器
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
            return 'Android'
        } else if (isiOS) {
            return 'iOS'
        } else {
            return '不明'
        }
    }
    else {
        return 'Web'
    }
}
//X-DU
function creatud() {
    var s = [];
    var hexDigits = '0123456789abcdef';
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4';
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    return uuid;
}
function getUuid() {
    var DU = localStorage.getItem('uuid');
    if (!DU) {
        var localDu = creatud();
        localStorage.setItem('uuid', localDu);
        return localDu;
    }
    return DU;
}
var DU = getUuid();
//X-MD 手机型号
function getModel() {
    let webLog = {}
    let userAgent = navigator.userAgent
    // 获取微信版本
    let m1 = userAgent.match(/MicroMessenger.*?(?= )/)
    if (m1 && m1.length > 0) {
        webLog.wechat = m1[0]
    }
    // 苹果手机
    if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
        // 获取设备名
        if (userAgent.includes('iPad')) {
            webLog.device = 'iPad'
        } else {
            webLog.device = 'iPhone'
        }
        // 获取操作系统版本
        m1 = userAgent.match(/iPhone OS .*?(?= )/)
        if (m1 && m1.length > 0) {
            webLog.system = m1[0].replace(/_/g, '.').replace(' OS ', '')
        }
    }
    // 安卓手机
    if (userAgent.includes('Android')) {
        // 获取设备名
        m1 = userAgent.match(/Android.*; ?(.*(?= Build))/)
        if (m1 && m1.length > 1) {
            webLog.device = m1[1]
        }
        // 获取操作系统版本
        m1 = userAgent.match(/Android.*?(?=;)/)
        if (m1 && m1.length > 0) {
            webLog.system = m1[0]
        }
    }
    var data = webLog.system || '';
    return data
}
//x-ov 手机型号后面的数字
function getModelData() {
    var status = judgeIosAndroid();
    if (status != 'Web') {
        var str = getModel();
        var pattern = new RegExp('[0-9]+');
        var num = str.match(pattern);
        return str.substring(num.index)
    }
}
function setBaseUrl(config) {
    //正式环境
    if (process.env.NODE_ENV === 'production') {
        config.baseURL = process.env.CommonFrontApi
    }
    return config;
}
// 1.添加请求拦截器
service.interceptors.request.use(config => {
    config = setBaseUrl(config);
    config.headers.common = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CI': process.env.XCompanyId,
        'X-DU': DU,
        'X-SV': '1',
        'X-PF': judgeIosAndroid(),
        'X-UA': navigator.userAgent,
        'X-MD': getModel(),
        'X-OV': getModelData(),
    }
    let requireUrl = ['/register/send_invite_email']
    if(requireUrl.includes(config.url)){
        config.headers.common['X-CT'] = getCookie('ct')
    }
    return config;
},
    // 对请求错误做些什么
    error => {
        return Promise.reject(error);
    });

//3.添加响应拦截器
service.interceptors.response.use(function (response) {
    if(response.status==200 && response.data.STATUS=='MAINTENANCE'){
      let data=response.data;
      sessionStorage.setItem('MAINTENANCE_URL',data.DATA.MAINTENANCE_URL);
      $router.replace('/z1100')
    }
    if(response.status==200 && !response.data.STATUS) {
      $router.replace('/z1200') // redirect to 500 error page when response is not json format
    }

    // 書籍のアップロード処理中に、誤った処理が実行されたことを示します
    if(response.data.ERROR && response.data.ERROR.CODE == 'E103-0335'){

        let localUserInfo = commonJs.getLocalLowerData('user','userRequestInfo') || {}
        if(localUserInfo.USER_REQUEST_SEQ_HASH_NO){
            
            getDocumentInfoForUrl('',localUserInfo.USER_REQUEST_SEQ_HASH_NO).then(res=>{
                if(res.data.STATUS == 'OK'){
                    $router.replace(res.url)
                }else{
                    cErrorDialog({
                        title: '',
                        left: 'cancel',
                        right: 'OK',
                        content: res.data.ERROR.MESSAGE,
                        cancelBtn: false,
                        confirm: () => {
                            $router.replace('/documentVerifySetEmail')
                        }
                    })
                }
            });
        }else{
            cErrorDialog({
                title: '',
                left: 'cancel',
                right: 'OK',
                content: 'お手数ですが、「OK」ボタン押下後に表示される画面からやり直してください。※お手続きは、必ず同じブラウザでお進みください。',
                cancelBtn: false,
                confirm: () => {
                    $router.replace('/documentVerifySetEmail')
                }
            })
        }
        return
    }
  return response
}, function (error) {
  window.vm.$f7.preloader.hide()
  if ( !error.response || !error.response.status ) {
    $router.replace('/z1200'); // redirect to 500 error page when any error in response
  } else if (error.response.status == 500){
    $router.replace('/z1200')
  }

  return Promise.reject(error)
});

export default service










// WEBPACK FOOTER //
// ./src/utils/httpRequest.js